module.exports = __webpack_public_path__ + "media/images/shopify_faq_2-c4c22bf0e6c06c74937ab1b0e43c18fc.png";